<template>
  <div id="data-list-list-view" class="data-list-container">
    <SubproyectosSidebar v-if="addNewDataSidebar" :propModeCreate="sidebarCreateMode" :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <div class="ml-6 mb-3 mt-3">
        <vs-button color="primary" type="border" icon="add" @click="handleCreate()">Crear subproyecto</vs-button>
    </div>

    <vs-table :data="subproyectos" ref="table" noDataText="No hay datos disponibles">
      <template slot="thead">
        <vs-th :key="indexth" v-for="(row, indexth) in table_headers" :sort-key="row.sortKey">
          <p class="product-name font-medium truncate">{{ row.title }}</p>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in subproyectos" >
          <vs-td :data="data[indextr].id_subproject">
            {{data[indextr].id_subproject}}
          </vs-td>

          <vs-td :data="data[indextr].description">
            {{data[indextr].description}}
          </vs-td>

          <vs-td :data="data[indextr].id_project">
            {{ data[indextr].project_desc }}
          </vs-td>

          <vs-td :data="data[indextr].is_active">
            {{data[indextr].is_active}}
          </vs-td>

          <vs-td :data="data[indextr].id_business_unit">
            {{data[indextr].business_unit_desc}}
          </vs-td>

          <vs-td class="whitespace-no-wrap" :data="data[indextr].actions">
            <feather-icon icon="Edit3Icon" svgClasses="w-5 h-5 hover:text-dark stroke-current" class="mr-6" @click.stop="handleEdit(data[indextr])"/>
            <feather-icon icon="XCircleIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" @click.stop="handleDeactivate(data[indextr])"/>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import SubproyectosModule from '@/store/subproyectos-module/moduleDataList.js'
import FeatherIcon from '../../../components/FeatherIcon.vue'
import { searchCompany } from '../../../config/companies.js'
import SubproyectosCreateUpdate from './SubproyectosCreateUpdate.vue'
import SubproyectosSidebar from './SubproyectosSidebar.vue'

export default {
  components: { FeatherIcon, SubproyectosCreateUpdate, SubproyectosSidebar },
  created () {
    this.company = searchCompany(this.$route.params.nameCompany)
    this.company_id = this.company.idCompany

    if (!SubproyectosModule.isRegistered) {
      this.$store.registerModule('SubproyectosModule', SubproyectosModule)
      SubproyectosModule.isRegistered = true
    }

    this.getSubproyectos()
  },
  data () {
    return {
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      sidebarCreateMode: true,
      company: null,
      company_id: '',
    }
  },
  computed: {
    subproyectos(){
      return this.$store.state.SubproyectosModule.subproyectos
    },
    table_headers(){
      return this.$store.state.SubproyectosModule.table_headers
    }
  },
  methods: {
    handleEdit(subproyecto){
      // console.log(subproyecto)
      this.sidebarData = subproyecto
      this.sidebarCreateMode = false
      this.toggleDataSidebar(true)
    },

    handleDeactivate(subproyecto){
      if(subproyecto.is_active == "N"){
        this.$vs.dialog({
          color: 'warning',
          title: 'Aviso',
          text: 'Este subproyecto ya se encuentra desactivado.',
          acceptText: 'Aceptar'
        })
        return
      };

      console.log("id subproyecto: ", subproyecto)
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirmar desactivar`,
        text: '¿Desea desactivar este subproyecto?',
        acceptText: "Aceptar",
        cancelText: "Cancelar",
        accept: this.deactivateSubproyecto.bind(this, subproyecto)
      })
    },

    handleCreate(){
      this.sidebarData = {}
      this.sidebarCreateMode = true
      this.toggleDataSidebar(true)
    },

    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
      if(!val){
        this.getSubproyectos()
      }
    },

    getSubproyectos(){
      this.$vs.loading()
      this.$store.dispatch('SubproyectosModule/getAllSubproyectos', { id_company: this.company_id, id_user: this.$store.state.auth.userDetails().id })
      .then(() => {
        console.log('subproyectos: ', this.subproyectos)
        this.$vs.loading.close()
      })
      .catch(() => {
        this.$vs.loading.close()

        this.$vs.dialog({
          color: 'danger',
          title: 'Error',
          text:
            'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
          acceptText: 'Aceptar'
        })
      })
    },

    deactivateSubproyecto(subproyecto){
      this.$vs.loading()
      this.$store.dispatch('SubproyectosModule/deactivateSubproyecto', subproyecto)
      .then((response) => {
        // this.$vs.loading.close()
        this.$vs.dialog({
          color:'success',
          title:'Aviso',
          text:'Subproyecto desactivado correctamente.',
          accept: this.getSubproyectos()
        })
      })
      .catch(() => {
        this.$vs.loading.close()

        this.$vs.dialog({
          color: 'danger',
          title: 'Error',
          text: 'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
          acceptText: 'Aceptar'
        })
      })
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
              Below media-queries is fix for responsiveness of action buttons
              Note: If you change action buttons or layout of this page, Please remove below style
            */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
